import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { connect } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import { toggleLeftmenu } from "../../store/actions"

// Reusable header components
import NavTabs from "../LayoutCommonComponents/NavTabs"
import HeaderIconButton from "../LayoutCommonComponents/HeaderIconButton"
import NotificationDropdown from "../LayoutCommonComponents/NotifcationDropdown"
import ActiveCityBadge from "../LayoutCommonComponents/ActiveCityBadge"

import { ICONS } from "../../constants/icons"
import { get } from "../../api/axios"
import endpoints from "../../api/endpoints"
import { getDefaultNavItems } from "../LayoutCommonComponents/NavTabs"

const Header = props => {
  const [navDropdownOpen, setNavDropdownOpen] = useState(false)
  const [currentUser, setCurrentUser] = useState(null)
  const authUser = useSelector(state => state.auth.currentUser)
  const location = useLocation()
  const navigate = useNavigate()
  const navItems = useMemo(
    () => getDefaultNavItems(authUser),
    [authUser],
  )

  useEffect(() => {
    const fetchMe = async () => {
      const response = await get(endpoints.getMe, {
        params: { with: "addresses.city" },
      })
      if (response?.data?.success) {
        setCurrentUser(response.data.result)
      }
    }
    fetchMe()
  }, [])

  const primaryCity = currentUser?.addresses?.[0]?.city?.city || "--"

  // Find active nav item based on current route
  const activeNavItem =
    navItems.find(
      item =>
        location.pathname === item.to ||
        location.pathname.startsWith(item.to + "/"),
    ) || navItems[0]

  function tToggle() {
    var body = document.body
    var windowSize = document.documentElement.clientWidth

    if (windowSize < 992) {
      // Below 992px: only toggle sidebar-enable, never collapse
      body.classList.toggle("sidebar-enable")
    } else {
      // Above 992px: toggle collapsed state
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
      body.getAttribute("data-sidebar-size") === "sm" && windowSize > 991
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm")
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          {/* Left side: Navigation tabs */}
          <div className="navbar-header-left">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <img
                src={ICONS.sidebarLeft}
                alt=""
                className="vertical-menu-btn-icon"
              />
            </button>
            <NavTabs />

            {/* ≤576px: compact nav dropdown (tabs stay visible above that) */}
            <div className="nav-dropdown-wrapper">
              <button
                type="button"
                className="nav-dropdown-toggle"
                onClick={() => setNavDropdownOpen(!navDropdownOpen)}
                aria-expanded={navDropdownOpen}
                aria-label="Primary navigation"
              >
                <img
                  src={activeNavItem.icon}
                  alt=""
                  className="nav-dropdown-toggle-icon"
                />
                <span className="nav-dropdown-toggle-label">
                  {activeNavItem.label}
                </span>
                <i className="fa fa-fw fa-chevron-down nav-dropdown-toggle-chevron" />
              </button>
              {navDropdownOpen && (
                <div className="nav-dropdown-menu">
                  <ul className="nav-dropdown-list">
                    {navItems.map(item => (
                      <li key={item.key} className="nav-dropdown-item">
                        <NavLink
                          to={item.to}
                          className={({ isActive }) =>
                            `nav-dropdown-link${
                              isActive ? " nav-dropdown-link--active" : ""
                            }`
                          }
                          onClick={() => setNavDropdownOpen(false)}
                        >
                          <img
                            src={item.icon}
                            alt=""
                            className="nav-dropdown-icon"
                          />
                          <span className="nav-dropdown-label">
                            {item.label}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Right side: Icons and city badge */}
          <div className="navbar-header-right">
            <HeaderIconButton
              iconSrc={ICONS.navFlags}
              label="My Flags"
              active={location.pathname.startsWith("/flags")}
              onClick={() => navigate("/flags")}
            />
            <NotificationDropdown />
            <HeaderIconButton
              iconSrc={ICONS.activityLog}
              label="Activity Log"
              active={location.pathname.startsWith("/activity-log")}
              onClick={() => navigate("/activity-log")}
            />
            <ActiveCityBadge
              iconSrc={ICONS.city}
              label="Active City"
              value={primaryCity}
            />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { leftMenu, leftSideBarType } = state.Layout
  return { leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  toggleLeftmenu,
})(withTranslation()(Header))
